import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import logoGold from '../../assets/logo/logo-gold.png';
import DeliveryModal from "./DeliveryModal"

const Navbar = ({ totalQuantity }) => {
    const [showMenuModal, setShowMenuModal] = useState(false);

    return (
        <>
            <nav className="w-full h-32 md:h-44 px-4 sm:px-6 md:px-8 lg:px-16 bg-black flex items-center justify-between">
                <Link to="/" className="flex-shrink-0">
                    <img className="w-24 md:w-40 h-auto" src={logoGold} alt="Parsley Logo" />
                </Link>

                <div className="hidden md:flex items-center gap-4 lg:gap-8">
                    <Link to="/" className="text-white text-sm lg:text-lg font-normal hover:text-orange-400 transition">Home</Link>
                    <button
                        type="button"
                        onClick={() => setShowMenuModal(true)}
                        className="text-white text-sm lg:text-lg font-normal hover:text-orange-400 transition"
                    >
                        Menu
                    </button>
                </div>

                <div className="flex items-center w-auto pr-2 md:pr-0 md:w-40">
                    <Link to="/cart" className="relative">
                        <FaShoppingCart className="text-white text-xl md:text-2xl lg:text-3xl" />
                        {totalQuantity > 0 && (
                            <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                                {totalQuantity}
                            </span>
                        )}
                    </Link>
                </div>
            </nav>

            <DeliveryModal isOpen={showMenuModal} onClose={() => setShowMenuModal(false)} pickupPath="/menu" />
        </>
    );
};

export default Navbar;
